module.exports = __webpack_public_path__ + "static/media/cta_share_a_class.cb81a469.svg";